// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1732":"d73c9be2","2094":"91e58265"}[chunkId] + ".chunk.css";
};